
import Auth from "@/lib/common/auth";
import VirRequest, {
  VirGetParam,
  VirListParam
} from "@/lib/model/vir/VirRequest";
import { Component, Vue } from "vue-property-decorator";
import MsgRequest, { MsgRequestParams } from "@/lib/model/message/MsgRequest";
import _ from "lodash-es";

class MessageStatus {
  label = "";
  value = 0;
}

@Component({
  components: {}
})
export default class MessageLog extends Vue {
  name = "message-log";
  searchTitle = "";
  searchText = "";
  virListParam = new VirListParam();
  virDelForm = new VirGetParam();
  hasNoList = false;
  dataList = [];
  tableLoading = false;
  page = 1;
  currentPageSize = 10;
  total = 0;
  msgRequestParams = new MsgRequestParams();
  messageStatus: MessageStatus[] = [
    { label: "全部", value: 1000 },
    { label: "等待结果", value: 0 },
    { label: "确认成功", value: 1 },
    { label: "确认失败", value: 2 },
    { label: "未发送", value: 255 }
  ];
  callStatus = 1000;
  msgStatus = 1000;
  emailStatus = 1000;

  rowStyle = {
    color: "#8B8F94",
    "font-weight": "400",
    "font-size": "14px"
  };

  mounted() {
    this.getDataList();
  }

  getDataList() {
    this.msgRequestParams.companyId = parseInt(Auth.companyId);
    if (this.msgStatus < 1000) {
      this.msgRequestParams.mobileSendStatusList = [this.msgStatus];
    } else {
      this.msgRequestParams.mobileSendStatusList = [];
    }
    if (this.callStatus < 1000) {
      this.msgRequestParams.callSendStatusList = [this.callStatus];
    } else {
      this.msgRequestParams.callSendStatusList = [];
    }
    if (this.emailStatus < 1000) {
      this.msgRequestParams.emailSendStatusList = [this.emailStatus];
    } else {
      this.msgRequestParams.emailSendStatusList = [];
    }

    MsgRequest.getMessageLogList(this.msgRequestParams).then(res => {
      if (res.code === 0) {
        this.total = res.data.count;
        this.dataList = res.data.list;
      } else {
        this.$message.error(res.message);
      }
    });
  }

  resetSearch() {
    this.callStatus = 1000;
    this.emailStatus = 1000;
    this.msgStatus = 1000;
    this.getDataList();
  }

  formatVirType(val: string) {
    if (val === "mp4") {
      return "视频";
    } else {
      return "音频";
    }
  }

  formatSendStatus(val: number) {
    if (val === 255) {
      return "未发送";
    } else if (val === 1) {
      return "确认成功";
    } else if (val === 2) {
      return "确认失败";
    } else {
      return "等待结果";
    }
  }

  reCreate(virId: number) {
    // this.tableLoading = true;
    this.virDelForm.companyId = parseInt(Auth.companyId);
    this.virDelForm.virId = virId;
    // 点击重新制作，应该跳转到制作视频页面
    this.$router.push("/vir/manual");
    // VirRequest.virCopy(this.virDelForm)
    //   .then(res => {
    //     if (res.code === 0) {
    //       this.$message.success("成功");
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   })
    //   .finally(() => {
    //     this.getDataList();
    //     this.tableLoading = false;
    //   });
  }

  delVirMp4(virId: number) {
    this.tableLoading = true;
    this.virDelForm.companyId = parseInt(Auth.companyId);
    this.virDelForm.virId = virId;
    VirRequest.virDelete(this.virDelForm)
      .then(res => {
        if (res.code === 0) {
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.message);
        }
      })
      .finally(() => {
        this.getDataList();
        this.tableLoading = false;
      });
  }

  copyVirMp4(url: string) {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = url;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  playVirMp4(url: string) {
    window.open(url);
  }

  searchVir() {
    console.log("searchVir");
  }

  formatSeconds(value: number) {
    let theTime = value; // 秒
    let middle = 0; // 分
    let hour = 0; // 小时

    if (theTime > 60) {
      middle = Number(theTime / 60);
      theTime = Number(theTime % 60);
      if (middle > 60) {
        hour = Number(middle / 60);
        middle = Number(middle % 60);
      }
    }
    let result = "" + Number(theTime) + "秒";
    if (middle > 0) {
      result = "" + Number(middle) + "分" + result;
    }
    if (hour > 0) {
      result = "" + Number(hour) + "小时" + result;
    }
    return result;
  }

  virStatusColor(val: number) {
    if (val === 255) {
      return "audit-color-4";
    } else if (val <= 3 && val >= 0) {
      return "audit-color-2";
    } else if (val === 4) {
      return "audit-color-1";
    } else {
      return "audit-color-3";
    }
  }
}
